/**
 * Adds soft scroll to all internal links
 */
import ViewportOffset from "./ViewportOffset";

export default class SoftScroll {

	static init() {
		let selectHref = window.location.href.split("#")[0];
		jQuery( 'a[href^="#"], a[href^="' + selectHref + '#"]' ).on( "click", SoftScroll.doScroll );
	}

	/**
	 *
	 * @param event Event
	 *
	 * @this HTMLElement
	 */
	static doScroll( event ) {
		let $this = jQuery( this );
		let $target = jQuery( this.hash );
		if ( '' === this.hash && this.href.split( "#" ).length === 2 ) {
			$target = jQuery( document.body );
		}
		if ( $this.data( 'menu-toggle' ) ) {
			jQuery( window ).triggerHandler('hs:menu-toggle-initial');
			jQuery( window ).trigger('theme:menu-toggle-initial');
		}
		if ( $target.length ) {
			event.preventDefault();
			jQuery( window ).trigger('theme:menu-toggle-initial');
			jQuery( "html, body" ).stop().animate({
				'scrollTop': ( $target.offset().top - ViewportOffset.calculateOffset() )
			}, 750, "swing" );
		}
	}
}
